import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-skip-navigation',
	templateUrl: './skip-navigation.component.html',
	styleUrls: ['./skip-navigation.component.scss']
})
export class SkipNavigationComponent implements OnInit {

	// Page skip-navigation
	skip_navigation = [
		{
			label: 'Skip to main content',
			url: 'main',
			newTab: false
		},
		{
			label: 'Contacts',
			url: 'https://www.flytap.com/suporte/contactos',
			newTab: true
		}
	];

	scrollingTimeout;
	isScrolling = false;

	TAP_gotTo(id) {
		// window.scroll(0, 0);
		const elementBody = document.getElementById(id);

		if (elementBody != null) {
			clearTimeout(this.scrollingTimeout);
			this.isScrolling = true;
			elementBody.focus();

			this.scrollingTimeout = setTimeout(() => {
				this.isScrolling = false;
			}, 600);
			elementBody.scrollIntoView({ block: 'start', behavior: 'smooth' });
		}
	}

	constructor() {}

	ngOnInit() {}
}
